import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { updateUserRoleMapping, fetchSystemRoles, SuperAdminUserMapping } from '../../../../modules/superadmin';
import { selectUpdateUserMappingLoading, selectSystemRoles } from '../../../../modules/superadmin/selectors';

interface Props {
  open: boolean;
  onClose: () => void;
  mapping: SuperAdminUserMapping | null;
}

const UpdateRoleModal: React.FC<Props> = ({ open, onClose, mapping }) => {
  const dispatch = useDispatch<AppDispatch>();
  const isUpdating = useSelector(selectUpdateUserMappingLoading);
  const roles = useSelector(selectSystemRoles);

  const [selectedRoleId, setSelectedRoleId] = useState<string>('');

  useEffect(() => {
    if (open && mapping) {
      dispatch(fetchSystemRoles());
      setSelectedRoleId(mapping.system_role.role_id.toString());
    }
  }, [open, mapping, dispatch]);

  const handleUpdate = () => {
    if (mapping && selectedRoleId) {
      dispatch(updateUserRoleMapping({
        mapping_id: mapping.mapping_id,
        system_role_id: Number(selectedRoleId)
      }));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Update User Role</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 2 }}>
          <TextField
            fullWidth
            label="User"
            value={mapping ? `${mapping.user.first_name} ${mapping.user.last_name}` : ''}
            disabled
            size="small"
            sx={{ mb: 3 }}
          />
          <TextField
            select
            fullWidth
            label="System Role"
            value={selectedRoleId}
            onChange={(e) => setSelectedRoleId(e.target.value)}
            size="small"
          >
            {Array.isArray(roles) && roles.map((role) => (
              <MenuItem key={role.role_id} value={role.role_id}>
                {role.role_name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: '#666' }}>
          Cancel
        </Button>
        <Button
          onClick={handleUpdate}
          variant="contained"
          disabled={isUpdating || !selectedRoleId || selectedRoleId === mapping?.system_role.role_id.toString()}
          sx={{
            textTransform: 'none',
            backgroundColor: '#5E8E7E',
            '&:hover': { backgroundColor: '#4A7A6A' }
          }}
        >
          {isUpdating ? 'Updating...' : 'Update Role'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRoleModal;
